export default "__VITE_ASSET__ujQJh83l__"